var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label flex",attrs:{"for":_vm.id}},[_c('span',{class:_vm.cutoffLabel ? 'truncate' : '',domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('Tippy',{staticClass:"flex items-start",attrs:{"content":_vm.tippy}},[_c('InformationCircle',{staticClass:"ml-2 inline-block w-3 h-3"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }